import { SidebarTrigger } from '@/components/ui/sidebar';
import { AuthButton } from '../auth/auth-button';
import { ThemeToggle } from '../theme-toggle';
import { motion } from 'framer-motion';
import { useAuth } from '@/contexts/auth-context';

export function GlobalHeader() {
        const { user } = useAuth();

        return (
                <motion.header
                        initial={{ y: -10, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        transition={{ duration: 0.2, ease: 'easeOut' }}
                        className="sticky top-0 z-50"
                >
                        <div className="relative">
                                {/* Main content */}
                                <div className="h-16 relative flex justify-between items-center px-5 border-b border-white/5 bg-[#0D0B14]/50 backdrop-blur-sm">
                                        {/* Left section */}
                                        <motion.div
                                                whileTap={{ scale: 0.95 }}
                                                transition={{
                                                        type: 'spring',
                                                        stiffness: 400,
                                                        damping: 17,
                                                }}
                                                className='flex items-center'
                                        >
                                                {user && <SidebarTrigger className="bg-transparent hover:bg-white/10 transition-colors text-white w-8 h-8 flex shrink-0 justify-center items-center rounded-lg p-0 mr-3" />}
                                                <img 
                                                        src="/chirpy-logo.png" 
                                                        alt="Chirpy Logo" 
                                                        className="h-12 w-auto object-contain"
                                                />
                                        </motion.div>

                                        {/* Right section */}
                                        <motion.div
                                                initial={{ opacity: 0, x: 10 }}
                                                animate={{ opacity: 1, x: 0 }}
                                                transition={{ delay: 0.2 }}
                                                className="opacity-100 flex items-center gap-x-4"
                                        >
                                                <ThemeToggle />
                                                <AuthButton />
                                        </motion.div>
                                </div>
                        </div>
                </motion.header>
        );
}
